import { render, staticRenderFns } from "./MA2.vue?vue&type=template&id=281b1fb3&scoped=true&"
import script from "./MA2.vue?vue&type=script&lang=js&"
export * from "./MA2.vue?vue&type=script&lang=js&"
import style0 from "./MA2.vue?vue&type=style&index=0&id=281b1fb3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "281b1fb3",
  null
  
)

export default component.exports